import React from 'react'
import styled from 'styled-components'

// Semantic, colorblind-considerate palette. Each state pairs a soft tint with
// a darker text/border of the same hue (>= 4.5:1 contrast). Color is never the
// sole signal — the label text and the leading dot are always present, so
// red (Dropped Off) and green (Completed) stay distinguishable.
export const ASSESSMENT_STATUS_STYLES = {
  'Completed': { bg: '#E6F4EA', text: '#137333', border: '#A8DAB5' },
  'Pending': { bg: '#FEF7E0', text: '#B06000', border: '#FDE293' },
  'Invite Pending': { bg: '#F1F3F4', text: '#5F6368', border: '#DADCE0' },
  'Dropped Off': { bg: '#FCE8E6', text: '#C5221F', border: '#F6AEA9' },
}

const DEFAULT_STYLE = { bg: '#F1F3F4', text: '#5F6368', border: '#DADCE0' }

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  background-color: ${props => props.$bg};
  color: ${props => props.$text};
  border: 1px solid ${props => props.$border};
`

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${props => props.$color};
`

const AssessmentStatusBadge = ({ status }) => {
  if (!status) return <span>-</span>
  const style = ASSESSMENT_STATUS_STYLES[status] || DEFAULT_STYLE
  return (
    <Badge $bg={style.bg} $text={style.text} $border={style.border}>
      <Dot $color={style.text} aria-hidden="true" />
      {status}
    </Badge>
  )
}

export default AssessmentStatusBadge
